<p-message
    *forPlan="['demo', 'basic']; shouldRender: true"
    class="message"
    [severity]="'warn'">
    <b>{{ label() }}</b>

    <p-button
        class="change-plan-button"
        [label]="'Change the plan'"
        [severity]="'contrast'"
        [icon]="'pi pi-credit-card'"
        [routerLink]="billingPageUrl" />
</p-message>
